module.exports = __webpack_public_path__ + "img/Group 75.7c3e4e99.svg";